import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hero call-out: "📖 Most-loved chapter this week — <title>".
 *
 * Pulls from /api/book/popular-chapter (last 7 days, ≥3 unique listeners).
 * Hidden entirely until there's real signal so visitors never see something
 * sad like "1 listen". Pure social proof — pulls newcomers a level deeper
 * instead of bouncing.
 */
export default function PopularChapterCallout() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => {
      fetch(`${API}/book/popular-chapter`)
        .then((r) => r.json())
        .then((d) => alive && setData(d))
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 5 * 60 * 1000); // refresh every 5 min
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  if (!data || data.chapter === null || data.chapter === undefined) return null;

  return (
    <a
      href="#read"
      className="popular-chapter-callout"
      data-testid="popular-chapter-callout"
      aria-label={`Most-loved chapter this week: ${data.title}`}
    >
      <span className="pop-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
          <path d="M12 21s-7.5-4.6-10-9.4C.4 8 2.6 4 6.7 4c2.3 0 3.9 1.3 5.3 3.2C13.4 5.3 15 4 17.3 4c4.1 0 6.3 4 4.7 7.6C19.5 16.4 12 21 12 21z" />
        </svg>
      </span>
      <span className="pop-text">
        <span className="pop-label">Most-loved chapter this week</span>
        <span className="pop-title">“{data.title}”</span>
      </span>
    </a>
  );
}
